<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/Page-header";
import appConfig from "../../../../../app.config";
import puntuationAPI from "@/services/standards/puntuation/puntuationAPI";
import DontExist from "@/components/company/components/DontExist"
import Style from "@/views/layouts/style"; 

/**
 * Form elements component
*/
export default {
  page: {
    title: "Configuración",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DontExist,
    Style,
   
  },
  data() {
    return {
      title: "Configuración",
      loading: true,

      items: [],

      lista: [],
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
    
    };
  },
 
  methods: {
    getList() {
      puntuationAPI.getpuntuation(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          
          let identification = response.data;
          console.log(identification);
          this.lista = identification
          console.log('data a mostrar:', this.lista)
          this.loading= false;
        })
        .catch((error) => {
          console.log(error);
         
        });
    },
  },

   mounted() {
    this.getList()
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if=" !loading && classificationID <= 4 ">  
   
    <div class="row">
      <div class="col-12">
        <div class="card">
         
          <div class="row" >
                <div class="col-lg-12">
                  <div class="card-body">
                    <div class="row pb-3">
                      <div class="col-6">
                        <div class="form-row row text-center">
                        <form class="form-inline">
                          <div class="col-sm-11 col-md-5">
                        <b-form-input
                          type="text"
                          name="search"
                          id="search"
                          
                          class="form-control px-2"
                          placeholder="Buscar"
                        ></b-form-input>
                      </div>
                      <div class="col-sm-1 pl-5">
                        <button type="submit" class="btn btn-primary px-2">Buscar</button>
                      </div>
                        
                        </form>
                      </div>
                      </div> 
                      <div class="col-6">
                        <div class="form-group text-right m-b-0">
                
              </div>
                      </div>
                    </div>

                    <div class="table-responsive">
                   
                      <table class="
                            pt-2
                            table
                            border-bottom
                            divide-y divide-gray-200
                            table-striped
                            rounded
                          ">
                        <thead >
                          <tr>
                            <th class="text-center align-middle">Item</th>
                            <th class="text-center align-middle">Nombre</th>
                           
                            <th class="text-center align-middle">Puntuación relativa</th>
                            <th class="text-center align-middle">Puntuación absoluta</th>
                            <th class="text-center align-middle">Operación</th>
                           
                            <th class="text-center align-middle">Estado</th>
                            
                            <th class="text-center align-middle">Acciones</th>
                          </tr>
                        </thead>
                        <tbody  class="bg-white divide-y divide-gray-200">
                          <tr v-for="dato in lista" :key="dato.id">
                           
                            <td class="text-center align-middle">
                              {{ dato.sequence }}
                            </td>    
                            <td class="text-center align-middle">
                              {{ dato.description }}
                            </td>              
                           <td class="text-center align-middle">
                            {{ dato.puntation_relative }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.puntation_absoluta }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.operation }}
                            </td>
                            <td class="text-center align-middle">
                              {{ dato.status }}
                            </td>
                           
                              <td class="text-center align-middle">
                              <div class="col-sm-12">
                                <b-dropdown  variant="primary">
                                  <template v-slot:button-content>
                                    <i class="mdi mdi-eye"></i>
                                  </template>
                                  <b-dropdown-item  :to="{ path: `/forms/configuracion/puntuacion-editar/${dato.id}` } ">Editar</b-dropdown-item>
                                  </b-dropdown>
                              </div>
                            </td>
                          </tr>

                       
                        </tbody>
                      </table>
                    
                      <div>
                       
   </div>
                    </div>
                  </div>
                </div>
              
                <!-- end col -->
              </div>

         
        </div>
      </div>
    </div>
  </div>

<div v-else-if=" !loading && classificationID > 3 " >
  <DontExist />
</div>

<div v-else-if="!loading">
  <DontExist />
</div>
<div v-else class="col-xl-12 text-center">
  <div class="text-center">
    <b-spinner variant="primary" label="Loading..."></b-spinner>
  </div>
</div> 
</div>
</div>
  </Layout>
</template>
